import { render, staticRenderFns } from "./SpringReceived.vue?vue&type=template&id=25872f2a&"
import script from "./SpringReceived.vue?vue&type=script&lang=js&"
export * from "./SpringReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports